import Vue from 'vue';
// @vuese
// Filter to truncate string
Vue.filter('truncate', function (value, limit, addDots = false) {
  if (value.length > limit) {
    value = `${value.substring(0, limit)}${addDots ? ' ...' : ''}`;
  }

  return value;
});